import toePreview from "../assets/3eff55309171e7c343ff84a180c50e38de5e5d6d.png";
import handLatPreview from "../assets/65c1d05dd063eb90d3a17e9773189a2a2183e23c.png";
import fingerPreview from "../assets/6b1e8eaaff957a4c9d2ef9aab244057446756c38.png";
import handPaPreview from "../assets/9393c75daa3e65bb34b4d8eaaf93ac6629233685.png";
import shoulderNeutralPreview from "../assets/a10ebd2342b58fec81f630cb29aeef026a9f5a44.png";
import ankleApPreview from "../assets/ae37f948abedf51a3757e67be67919958f4eb0f2.png";
import wristLatPreview from "../assets/f64ae7171f2c2fad5cf2bb94d02b52c235e1c8b9.png";
import type {
  UnifiedTableRecord,
  UnifiedTableRow,
} from "../../../shared/ui/data-table/model/data-table-contract";

export interface DicomStudy {
  id: string;
  studyDate: string;
  modality: string;
  studyDescription: string;
  previewImage: string;
  previewAlt: string;
  viewUrl: string;
}

export const dicomStudies: DicomStudy[] = [
  {
    id: "dicom-2022-11-10-ankle",
    studyDate: "11/10/2022",
    modality: "CR",
    studyDescription: "Ankle AP",
    previewImage: ankleApPreview,
    previewAlt: "Ankle AP x-ray preview",
    viewUrl: ankleApPreview,
  },
  {
    id: "dicom-2022-11-01-hand",
    studyDate: "11/01/2022",
    modality: "CR",
    studyDescription: "HAND",
    previewImage: handPaPreview,
    previewAlt: "Hand x-ray preview",
    viewUrl: handPaPreview,
  },
  {
    id: "dicom-2022-11-01-finger",
    studyDate: "11/01/2022",
    modality: "CR",
    studyDescription: "FINGER",
    previewImage: fingerPreview,
    previewAlt: "Finger x-ray preview",
    viewUrl: fingerPreview,
  },
  {
    id: "dicom-2022-10-24-shoulder",
    studyDate: "10/24/2022",
    modality: "CR",
    studyDescription: "SHOULDER NEUTRAL",
    previewImage: shoulderNeutralPreview,
    previewAlt: "Shoulder neutral x-ray preview",
    viewUrl: shoulderNeutralPreview,
  },
  {
    id: "dicom-2021-08-20-toe",
    studyDate: "08/20/2021",
    modality: "CR",
    studyDescription: "toe",
    previewImage: toePreview,
    previewAlt: "Toe x-ray preview",
    viewUrl: toePreview,
  },
  {
    id: "dicom-2019-04-05-wrist",
    studyDate: "04/05/2019",
    modality: "CR",
    studyDescription: "WRIST LAT",
    previewImage: wristLatPreview,
    previewAlt: "Wrist lateral x-ray preview",
    viewUrl: wristLatPreview,
  },
  {
    id: "dicom-2018-06-09-hand-lat",
    studyDate: "06/09/2018",
    modality: "CR",
    studyDescription: "HAND LAT",
    previewImage: handLatPreview,
    previewAlt: "Hand lateral x-ray preview",
    viewUrl: handLatPreview,
  },
];

const dicomStudyRows: UnifiedTableRow[] = dicomStudies.map((study) => ({
  ...study,
}));

export const dicomStudiesRecord: UnifiedTableRecord = {
  module: "DICOM Studies",
  pageTitle: "DICOM Studies",
  sections: [
    {
      id: "dicom-studies",
      title: "DICOM Studies",
      tables: [
        {
          id: "dicom-studies-table",
          columns: [
            {
              key: "studyDate",
              header: "Study Date",
              sortable: true,
              width: "19%",
            },
            {
              key: "modality",
              header: "Modality",
              sortable: true,
              width: "18%",
            },
            {
              key: "studyDescription",
              header: "Study Description",
              sortable: true,
              width: "32%",
            },
            {
              key: "previewImage",
              header: "Preview",
              rendererId: "dicomPreview",
              width: "18%",
            },
            {
              key: "viewUrl",
              header: "",
              rendererId: "dicomAction",
              align: "right",
              width: "13%",
            },
          ],
          rows: dicomStudyRows,
          ui: {
            searchable: true,
            searchPlaceholder: "Search...",
            searchKeys: ["studyDate", "modality", "studyDescription"],
            defaultRowsPerPage: 10,
            rowsPerPageOptions: [5, 10, 20, 25],
            emptyMessage: "No DICOM studies found",
            emptyStateIconRendererId: "dicomStudies",
            showPaginator: true,
          },
        },
      ],
    },
  ],
};
